// extracted by mini-css-extract-plugin
module.exports = {"IndustryLeadingC":"IndustryLeadingC_IndustryLeadingC__SjWJq"};